import React from 'react';
import { Award, Medal, Trophy } from 'lucide-react';

const BadgeDisplay = ({ badges = [], consecutiveDays = 0 }) => {
  const badgeConfig = {
    bronze: {
      label: '3 Days Bronze',
      icon: Award,
      color: 'text-amber-700',
      bg: 'bg-amber-100',
      border: 'border-amber-400'
    },
    silver: {
      label: '7 Days Silver',
      icon: Medal,
      color: 'text-gray-600',
      bg: 'bg-gray-100',
      border: 'border-gray-400'
    },
    gold: {
      label: '14 Days Gold',
      icon: Trophy,
      color: 'text-yellow-600',
      bg: 'bg-yellow-100',
      border: 'border-yellow-400'
    }
  };

  if (badges.length === 0) {
    return (
      <div className="text-center p-4 text-muted-foreground font-sketch">
        <p className="text-sm">Generate stories {consecutiveDays > 0 ? `for ${Math.max(0, 3 - consecutiveDays)} more days` : '3 days in a row'} to earn your first badge!</p>
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-2">
      {badges.map((badge) => {
        const config = badgeConfig[badge];
        if (!config) return null;
        const Icon = config.icon;

        return (
          <div
            key={badge}
            className={`inline-flex items-center gap-2 px-3 py-2 rounded-lg border-2 ${config.bg} ${config.border} ${config.color} font-sketch shadow-[2px_2px_0px_rgba(0,0,0,0.1)]`}
          >
            <Icon className="w-5 h-5" />
            <span className="font-semibold text-sm">{config.label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default BadgeDisplay;
